import WhatsappTemplatesAPI from '../../api/whatsappTemplates';

const state = {
  records: [],
  selectedInboxId: null,
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isSyncing: false,
  },
};

const getters = {
  getTemplates: $state => $state.records,
  getSelectedInboxId: $state => $state.selectedInboxId,
  getUIFlags: $state => $state.uiFlags,
  getTemplatesByStatus: $state => status =>
    $state.records.filter(t => t.status === status),
  getTemplatesByCategory: $state => category =>
    $state.records.filter(t => t.category === category),
};

const actions = {
  async fetchTemplates({ commit, state: $state }, { inboxId, params } = {}) {
    const targetInbox = inboxId || $state.selectedInboxId;
    if (!targetInbox) return;

    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await WhatsappTemplatesAPI.list(targetInbox, params);
      commit('SET_TEMPLATES', data.data || []);
      commit('SET_SELECTED_INBOX', targetInbox);
    } catch (error) {
      commit('SET_TEMPLATES', []);
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async createTemplate({ commit, dispatch, state: $state }, templateData) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await WhatsappTemplatesAPI.create(
        $state.selectedInboxId,
        templateData
      );
      // Re-fetch to update the list with the new template
      await dispatch('fetchTemplates', { inboxId: $state.selectedInboxId });
      return data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async updateTemplate(
    { commit, dispatch, state: $state },
    { templateId, templateData }
  ) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await WhatsappTemplatesAPI.update(
        templateId,
        $state.selectedInboxId,
        templateData
      );
      await dispatch('fetchTemplates', { inboxId: $state.selectedInboxId });
      return data;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async deleteTemplate({ dispatch, state: $state }, templateName) {
    await WhatsappTemplatesAPI.deleteTemplate(
      $state.selectedInboxId,
      templateName
    );
    // Re-fetch after delete
    await dispatch('fetchTemplates', { inboxId: $state.selectedInboxId });
  },

  async syncTemplates({ commit, dispatch, state: $state }) {
    commit('SET_UI_FLAG', { isSyncing: true });
    try {
      await WhatsappTemplatesAPI.sync($state.selectedInboxId);
      // Sync job runs in background — re-fetch immediately for current data,
      // user can sync again for latest updates
      await dispatch('fetchTemplates', { inboxId: $state.selectedInboxId });
    } finally {
      commit('SET_UI_FLAG', { isSyncing: false });
    }
  },

  setSelectedInbox({ commit }, inboxId) {
    commit('SET_SELECTED_INBOX', inboxId);
  },

  async generateTemplate(
    { state: $state },
    { prompt, language, category, inboxId } = {}
  ) {
    const target = inboxId || $state.selectedInboxId;
    const { data } = await WhatsappTemplatesAPI.generateWithAi(target, {
      prompt,
      language,
      category,
    });
    return data;
  },
};

const mutations = {
  SET_TEMPLATES($state, templates) {
    $state.records = templates;
  },
  SET_SELECTED_INBOX($state, inboxId) {
    $state.selectedInboxId = inboxId;
  },
  SET_UI_FLAG($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
